import { render } from "./SectionOBForm.vue?vue&type=template&id=1ab89160&scoped=true"
import script from "./SectionOBForm.vue?vue&type=script&lang=js"
export * from "./SectionOBForm.vue?vue&type=script&lang=js"

import "./SectionOBForm.vue?vue&type=style&index=0&id=1ab89160&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab89160"]])

export default __exports__